<template>
  <div class="map-wrap">
    <yandex-map
      :coords="coords"
      :zoom="zoom"
      :controls="controls"
      :scroll-zoom="false"
      style="width: 100%; height: 520px;"
      map-type="map"
    >
      <ymap-marker
        v-for="(balloon, index) in balloons"
        :marker-id="balloon.id"
        marker-type="circle"
        :coords="balloon.coord_line.split(',')"
        circle-radius="280"
        :hint-content="balloon.title"
        :marker-fill="getFill(balloon.stats.trust.coefficient)"
        :marker-stroke="{color: '#ffffff', width: 1}"
        :balloon="{header: 'header', body: 'body', footer: 'footer'}"
        :balloon-template="balloonTemplate(balloon.title, balloon.id, balloon.stats.trust, balloon.stats.attendance)"
        :key="index"
      >
      </ymap-marker>
    </yandex-map>
  </div>
</template>

<script>

  export default {
    name: "Ymap",
    props: {
      coords: {
        type: Array
      },
      balloons: {
        type: Array
      }
    },
    data() {
      return {
        zoom: 10,
        controls: [
          'zoomControl',
          'searchControl'
        ],
        eventPosts: false,
      }
    },
    methods: {
      getFill(coefficient) {
        let fill = {width: 2};

        if (coefficient < 0) {
          return  {...fill, color: "#ff0000"};
        }

        if (coefficient === 0) {
          return  {...fill, color: "#808080"};
        }

        if (coefficient > 0) {
          return  {...fill, color: "#00a550"};
        }
      },
      balloonTemplate(title, id, trust, attendance) {
        let tonalList = `<hr>
                          <div><b>Охват: ${attendance}</b></div>
                          <div>Тональность:</div>
                          <ul class="event-positive-list">
                            <li class="event-positive-list__item event-positive-list--positive">
                              <i class="material-icons" style="font-size: 16px">
                                  sentiment_very_satisfied
                              </i>: ${trust.positive}
                            </li>
                            <li class="event-positive-list__item event-positive-list--neutral">
                              <i class="material-icons" style="font-size: 16px">
                                  sentiment_satisfied
                              </i>: ${trust.netural}
                            </li>
                            <li class="event-positive-list__item event-positive-list--negative">
                              <i class="material-icons" style="font-size: 16px">
                                  sentiment_very_dissatisfied
                              </i>: ${trust.negative}
                            </li>
                          </ul>
                          <hr>`;

        return `
          <h1>${title}</h1>
          ${tonalList}
         <a href="#posts?id=${id}">показать посты</a>
      `
      },
    },
    watch: {
      '$route'(val) {
        let hash = '#';
        if(val.fullPath.includes(hash)) {
          this.$emit('showPosts', val.fullPath.split('?')[1]);
        }
      }
    },
  };
</script>

<style>
  .map-wrap {
    width: 100%;
    margin-top: 3px;
  }
  .event-positive-list {
    padding: 0;
    margin: 0;
    list-style: none;
    display: flex;
  }
  .event-positive-list__item {
    display: flex;
    align-items: center;
    margin-bottom: 3px;
    margin-right: 7px;
  }
  .event-positive-list__item:last-child {
    margin-right: 0;
  }
  .event-positive-list--positive {
    color: #15cf49;
  }
  .event-positive-list--neutral {
    color: #b3bccc;
  }
  .event-positive-list--negative {
    color: #f75b5b;
  }
</style>
